import React from 'react'
import { Link } from 'react-router'
export default store => [
  {
    title: '名称',
    render: ({ title, id }) => (
      <Link to={`/localMerchant/potentialCustomers/pushDetail/${id}`}>
        {title}
      </Link>
    )
  },
  {
    title: '发送人数',
    dataIndex: 'customer_count'
  },
  {
    title: '查看人数',
    dataIndex: 'viewed_count'
  },
  // {
  //   title: '回访人数',
  //   dataIndex: 'contacted_count'
  // },
  {
    title: '转为客资',
    dataIndex: 'guest_count'
  },
  {
    title: '执行时间',
    dataIndex: 'created_at'
  },
  {
    title: '操作',
    render: ({ id }) => <a onClick={store.delPush(id)}>删除</a>
  }
]
